import { a as y, c as l } from "./createOperation-Opo4US4u.js";
import { M, _ as h, e as P, f as I, g as F, h as S, j as C, i as L, k as A, a7 as B, a5 as U, a3 as E, a8 as W, a2 as T, a6 as x, a4 as w, m as O, l as _, n as N, V as R, o as k, p as m, q as H, r as z, u as D, s as V, t as j, v as G, w as J, x as K, D as X, F as Y, H as Z, J as $, y as q, X as b, A as aa, z as ea, B as ta, C as sa, E as oa, G as ia, I as na, W as ra, K as ua, Z as ya, Y as la, $ as ca, L as pa, N as da, O as fa, P as Qa, a0 as ga, a1 as va, Q as Ma, R as ha, S as Pa, T as Ia, U as Fa } from "./sportEventQuery-D0RPRU_6.js";
import { p as Ca } from "./personQuery-kyMqzCtB.js";
import { M as Aa, b as Ba, a as Ua, d as Ea, e as Wa, f as Ta, h as xa, m as wa, g as Oa, n as _a, i as Na, r as Ra, s as ka, j as ma, k as Ha, u as za, v as Da } from "./viewOptionQuery-CA9LgZQl.js";
import { n as ja } from "./notificationSubmitFeedback-_YcWy0Xu.js";
const c = y(({ member: a, authorizedPuids: i }) => {
  var o, t, s;
  return {
    isAuthorized: !!(a != null && a.id.puid && i.has(a.id.puid)),
    puid: (a == null ? void 0 : a.id.puid) ?? null,
    ottId: (a == null ? void 0 : a.id.ottId) ?? null,
    displayName: (a == null ? void 0 : a.displayName) ?? null,
    isAdmin: !!((o = a == null ? void 0 : a.family) != null && o.familyAdmin),
    avatarsUrl: ((t = a == null ? void 0 : a.avatar) == null ? void 0 : t.avatarsUrl) ?? null,
    hasSubscription: !!((s = a == null ? void 0 : a.subscriptionInfo) != null && s.hasSubscription),
    passportEmail: (a == null ? void 0 : a.__typename) === "UserProfile" ? a.passportEmail : "",
    passportLogin: (a == null ? void 0 : a.__typename) === "UserProfile" ? a.passportLogin : ""
  };
}), p = y(({ familyData: a }) => {
  var t, s, n, r, u;
  const i = new Set(
    (s = (t = a.yandex) == null ? void 0 : t.multiAccounts) == null ? void 0 : s.accounts.map((e) => e.puid)
  ), o = (n = a.family) != null && n.members ? a.family.members.filter((e) => e == null ? void 0 : e.id.puid).map((e) => c({ member: e, authorizedPuids: i })) : [];
  return {
    canInviteUser: !!((r = a.family) != null && r.canInviteUser),
    familyAdmin: !!((u = a.family) != null && u.familyAdmin),
    members: o
  };
}), d = {
  name: "Family",
  body: "query Family { userProfile { ...FamilyFragment } } fragment FamilyFragment on UserProfileInterface { family { canInviteUser familyAdmin members(filter: {types: [USER_PROFILE]}) { ...FamilyMember } } ...MultiAccountsFragment } fragment FamilyMember on UserProfileInterface { __typename id { puid ottId } displayName avatar { avatarsUrl } subscriptionInfo { hasSubscription } ... on UserProfile { passportLogin passportEmail } family { familyAdmin } } fragment MultiAccountsFragment on UserProfileInterface { yandex { multiAccounts { accounts( filter: {includeCurrentAccount: false, includeCurrentFamilyMembers: true} ) { puid } } } }",
  get variables() {
  },
  get query() {
  }
}, Q = l(d, {
  resolve: (a) => ({
    familyData: (a == null ? void 0 : a.userProfile) ?? null
  }),
  hydrate: (a) => a.familyData ? p({
    familyData: a.familyData
  }) : null
});
export {
  Aa as MovieNotFoundError,
  M as MutationError,
  h as SportEventSelectionItemType,
  P as addToSearchHistoryMutation,
  I as assignDcbSubscriptionMutation,
  Ba as bootstrapQuery,
  F as channelCategoryListQuery,
  S as channelListQuery,
  C as channelProgramInfoQuery,
  L as channelQuery,
  Ua as compositeOffersQuery,
  A as continueWatchingQuery,
  B as createLegacyClipPlayerBaseInfo,
  U as createLegacyEpisodePlayerBaseInfo,
  E as createLegacyFilmPlayerBaseInfo,
  W as createLegacyOttTrailerPlayerBaseInfo,
  T as createLegacyPlayerBaseInfoContent,
  x as createLegacyTvChannelPlayerBaseInfo,
  w as createLegacyVideoPlayerBaseInfo,
  Ea as createUserProfileMutation,
  Wa as experimentsQuery,
  Q as familyAccountsQuery,
  Ta as favoritesQuery,
  xa as historyQuery,
  wa as mineQuery,
  O as movieCardContentActionsQuery,
  _ as movieCardQuery,
  N as movieDirectorsFilmographyQuery,
  R as moviePlannedToWatchQuery,
  k as moviePromoContentActionsQuery,
  Oa as movieQuery,
  m as movieSimilarQuery,
  H as movieWebPageQuery,
  _a as notificationMarkViewedMutation,
  ja as notificationSubmitFeedbackMutation,
  Na as notificationsByConsumerQuery,
  Ca as personQuery,
  z as personSeoMetaQuery,
  D as playerBaseInfoQuery,
  V as playerMetaQuery,
  j as playerStreamMetaQuery,
  G as purchasesQuery,
  Ra as remoteConfigQuery,
  J as removeContinueWatchingItemMutation,
  K as removeFromSearchHistoryMutation,
  X as removeMovieEmotionMutation,
  Y as removeMovieNotInterestedMutation,
  Z as removeMoviePlannedToWatchMutation,
  $ as removeMovieWatchedMutation,
  q as removePlannedToWatchMutation,
  b as saveLastWatchedChannel,
  aa as seasonWithEpisodesQuery,
  ea as seasonsMetadataQuery,
  ta as selectionQuery,
  sa as setMovieEmotionMutation,
  oa as setMovieNotInterestedMutation,
  ia as setMoviePlannedToWatchMutation,
  na as setMovieWatchedMutation,
  ka as setPlannedToWatchMutation,
  ra as setWatchParamsMutation,
  ua as showcaseQuery,
  ya as sportEventQuery,
  la as sportShowcaseQuery,
  ca as subscriptionInfoQuery,
  ma as subscriptionPurchaseOptionsListQuery,
  Ha as subscriptionPurchaseOptionsQuery,
  pa as suggestEmptyPrefixQuery,
  da as suggestSearchQuery,
  fa as suggestSelectionQuery,
  Qa as timingsUserCredentialsQuery,
  ga as updatePreferredWatchingLanguageMutation,
  za as userProfileQuery,
  va as userSettingsQuery,
  Da as viewOptionQuery,
  Ma as watchingHistoryQuery,
  ha as watchingProgressQuery,
  Pa as yangoBootstrapQuery,
  Ia as yangoCrossRedirectQuery,
  Fa as yangoTouchFilmPageQuery
};
